import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // запросы, которые можно слать как есть
    if (this.canSendWithoutAuthToken(req)) {
      return next.handle(req);
    }

    // запросы с файлами — не трогаем Content-Type
    if (this.isRequestWithFile(req)) {
      req = this.setHeaders(req); // без Authorization
      return next.handle(req);
    }

    // обычные запросы — просто выставляем Content-Type
    req = this.setHeaders(req, 'Content-Type', 'application/json');
    return next.handle(req);
  }

  private canSendWithoutAuthToken(req: HttpRequest<any>): boolean {
    return req.url.includes('language')
      || req.url.includes('i18n')
      || (req.url.includes('token') && req.method === 'POST')
      || (req.url.includes('frontCustomization') && req.method === 'GET');
  }

  private isRequestWithFile(req: HttpRequest<any>): boolean {
    return (req.url.includes('unit/import') && req.method === 'POST')
      || (req.url.includes('frontCustomization') && req.method === 'POST');
  }

  private setHeaders(req: HttpRequest<any>, ...headers: string[]): HttpRequest<any> {
    let result = req.headers || new HttpHeaders();

    for (let i = 0; i < headers.length; i += 2) {
      result = result.set(headers[i], headers[i + 1]);
    }

    return req.clone({ headers: result });
  }
}
